import React, { Fragment, useEffect, useState } from 'react'
import DataGrid, {Pagenation} from '../../../../components/dataGrid'
import tremApi from '../../../../util/tremApi'
import G from '../../../../util/globalFunction'

import ModalBox, { usePopup } from '../../../../components/modalBox'
import DeptAdd from '../../collabi/myPage/user/popup/deptAdd'
export default props => {
    const {SINGLE_MODE, MASTER_TYPE, USE_ADD_DEPT, COMPANY_SKEY, getPopupValue, detail, CHOICE_IN_NULL, popupTitle} = props //popupTitle[client:거래처, default: 부서]
    const [dataStore, setDataStore] = useState({
        data : [],
        totalCount:0,
        page:0, 
        pageCount : 5
    })

    //검색(부서명)
    const [deptFormData, setDeptFormData] = useState({
        MASTER_NAME: ""
    })

    const [selectGrid, setSelectGrid] = useState({})

    useEffect(() => {
        detail===true
        ?setDetailDeptGrid(1)
        :setDeptGrid(1)
    },[])

    useEffect(() => {
        getPopupValue(selectGrid)
    },[selectGrid])

    const setDeptGrid = props =>{
        const page = props
        const gridProps = {
            MASTER_NAME:deptFormData.MASTER_NAME,
            MASTER_TYPE:MASTER_TYPE,
            COMPANY_SKEY:COMPANY_SKEY,
            page:page,
            rows:5
        }
        tremApi('/r/master/companyNdept/list/json', G.removeEmptyUndefinedOrNull(gridProps)).then(grid => { 
            const totalCount = grid.total
            const pageCount = dataStore.pageCount
            const page = dataStore.page || 0
            const data = grid.rows.slice(page * pageCount, (page + 1) * pageCount)
            setDataStore({...dataStore, totalCount, pageCount, page, data }) 
        })
            
    }

    const setDetailDeptGrid = props =>{
        const page = props
        const gridProps = {
            DEPT_NAME:deptFormData.MASTER_NAME,
            DEPT_TYPE:MASTER_TYPE,
            NOT_IN_COMPANY_SKEY:COMPANY_SKEY,
            CHOICE_IN_NULL,
            page:page,
            rows:5
        }
        tremApi('/r/dept/list/json', G.removeEmptyUndefinedOrNull(gridProps)).then(grid => { 
            const totalCount = grid.total
            const pageCount = dataStore.pageCount
            const page = dataStore.page || 0
            const data = grid.rows.slice(page * pageCount, (page + 1) * pageCount)
            setDataStore({...dataStore, totalCount, pageCount, page, data }) 
        })
            
    }

    const { data, totalCount, pageCount, page} = dataStore

    // 페이지 이동
    const hangleChangePage = page => {
        detail===true
        ?setDetailDeptGrid(page+1)
        :setDeptGrid(page+1)
    }

    const pageNationsInfo = { totalCount, pageCount, page, hangleChangePage }

    // 부서추가
    const deptAddPopupProps = usePopup(G.t("trem.lang.home.0503"))
    const DeptAddPopup = popupProps =>{
        const { open, handleClose } = popupProps
        const buttons = [
            {
                title :G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose,  
            }
        ]
        const deptAddPopupBtn = {
            COMPANY_SKEY,
            handleClose,
            setDeptGrid
        }

        return (
            open &&(
                <ModalBox {...popupProps} buttons={buttons} height="370">
                    <DeptAdd {...deptAddPopupBtn}/>
                </ModalBox>
            )
        )
    }

    //초기화
    const resetBtn = () =>{
        setDeptFormData({...deptFormData, MASTER_NAME: ""})
    }
    //조회
    const searchBtn = () =>{
        detail===true
        ?setDetailDeptGrid(1)
        :setDeptGrid(1)
    }

    return (
        <div>
            <table className="popup_table_type1" style={{marginBottom: '10px'}}>
                <caption>부서검색 팝업 표 - 부서{ popupTitle==="client"&& ", 거래처 구분"}로 구성 </caption>
                <tbody>
                    <tr>
                        <th scope='row'><label htmlFor="MASTER_NAME">{popupTitle==="client"?"거래처":"부서"}</label></th>
                        <td>
                            <input title="거래처, 부서 입력" id="MASTER_NAME" type="text" name="MASTER_NAME" value={deptFormData.MASTER_NAME} 
                                onChange={e => setDeptFormData({...deptFormData, MASTER_NAME: e.target.value})}/>
                        </td>
                        {
                        popupTitle==="client"
                        &&<Fragment>
                            <th scope='row'>거래처 구분</th>
                            <td>
                                <select title="거래처 구분" disabled>
                                    <option value="">부서</option>
                                    <option value="">거래처</option>
                                </select>
                            </td>
                        </Fragment>
                        }
                    </tr>
                </tbody>
            </table> 
            <div className="text-right btn_type4 mb-6">
                {USE_ADD_DEPT==="Y"&&<a href="javascript:void(0);" onClick={()=>deptAddPopupProps.setOpen(true)}>
                    {G.t('trem.lang.home.0179')}
                    {/* 추가 */}
                </a>}
                <a href="javascript:void(0);" onClick={resetBtn} className="">
                    {G.t('trem.lang.home.0236')}
                    {/* 초기화 */}
                </a>
                <a href="javascript:void(0);" onClick={searchBtn} className="red">조회</a>
            </div>
            {
            detail===true
            ?<DataGrid data={data}>
            <div title={G.t('trem.lang.home.0200')}/* 선택 */
                type="string" align="center" width="0.5fr" sort={false} filter={false} className="font-semibold" 
                render = {(row, rowIndex, columnIndex, field)=>{
                    return(
                        
                            <input
                                title="선택"
                                type="checkbox"
                                name = "deptCheckBox"
                                onKeyPress={(e)=>{
                                    if(e.code==="Enter"){
                                        const checkboxes = document.getElementsByName('deptCheckBox')
                                        for (let i = 0; i < checkboxes.length; i++) {
                                            checkboxes[i].checked = false
                                        }
                                        checkboxes[rowIndex].checked = true
                                        setSelectGrid(row)
                                    }
                                }}
                                onChange={() => { 
                                    const checkboxes = document.getElementsByName('deptCheckBox')
                                    for (let i = 0; i < checkboxes.length; i++) {
                                        checkboxes[i].checked = false
                                    }
                                    checkboxes[rowIndex].checked = true

                                    setSelectGrid(row)
                                }}
                            />
                        
                    )
                }
            }/>
            <div title={G.t('trem.lang.home.0530')} field="CODE" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 부서코드 */}
            <div title={G.t('trem.lang.home.0531')} field="DEPT_NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 부서명 */}
            <div title={G.t('trem.lang.home.1171')} field="DEPT_NAME_EN" type="string" align="center" width="1fr" sort={false} filter={false}/>{/*영문부서명*/}
            <div title={G.t('trem.lang.home.0169')} field="STATUS_NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 상태 */}         
            <div title={G.t('trem.lang.home.0534')} field="DIRECTOR_NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 부서장 */}
            <div title={G.t('trem.lang.home.0074')} field="NOTE" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 비고 */} 
            </DataGrid>
            :<DataGrid data={data}>
            <div title={G.t('trem.lang.home.0200')}/* 선택 */
                type="string" align="left" width="0.5fr" sort={false} filter={false}
                render = {(row, rowIndex, columnIndex, field)=>{
                    return(
                        <input
                            title="선택"
                            type="checkbox"
                            name = "deptCheckBox"
                            onKeyDown={(e)=>{
                                if(e.code==="Enter"){
                                const checkboxes = document.getElementsByName('deptCheckBox')
                                for (let i = 0; i < checkboxes.length; i++) {
                                    checkboxes[i].checked = false
                                }
                                checkboxes[rowIndex].checked = true
                                setSelectGrid(row)
                                }
                            }}
                            onChange={() => { 
                                const checkboxes = document.getElementsByName('deptCheckBox')
                                for (let i = 0; i < checkboxes.length; i++) {
                                    checkboxes[i].checked = false
                                }
                                checkboxes[rowIndex].checked = true

                                setSelectGrid(row)
                            }}
                        />
                    )
                }
            }/>
            <div title={G.t('trem.lang.home.0279') /* 거래처(부서명) */} field="MASTER_NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>
            <div title={G.t('trem.lang.home.0169')} field="STATUS_NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 상태 */}
            <div title={G.t('trem.lang.home.0280') /* 거래처(부서)구분 */} field="MASTER_TP_NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>
            <div title={G.t('trem.lang.home.0281') /* 거래처(부서)장 */} field="MASTER_DIRECTOR" type="string" align="center" width="1fr" sort={false} filter={false}/>
            <div title={G.t('trem.lang.home.0514') /* 전화번호 */} field="MASTER_TEL" type="string" align="center" width="1fr" sort={false} filter={false}/>
            <div title={G.t('trem.lang.home.0074')} field="NOTE" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 비고 */}
            </DataGrid>
            }
            
            <div className="self-center mt-6">
                <Pagenation {...pageNationsInfo} />
            </div>
            <DeptAddPopup {...deptAddPopupProps}/>
        </div>
    )
}